import { service } from '../index.js'

// 钱包
export const wallet = {
  // 后台：流水列表
  adminRecords: (params) => {
    return service.get('/wallet/admin/records', { params })
  },
  // 后台：提现列表
  adminWithdraws: (params) => {
    return service.get('/wallet/admin/withdraws', { params })
  },
  // 后台：处理提现（同意/拒绝）
  adminHandleWithdraw: (data) => {
    return service.post('/wallet/admin/handleWithdraw', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/wallet.js